import React, { useState } from 'react';
import { supabase } from '../supabase';
import './Login.css';

export default function Login({ onLogin, onBack }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setMessage('');
    if(!email || !password) { setError('Please fill in all fields.'); return; }
    if(password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if(mode === 'signup') {
      if(!name) { setError('Please enter your name.'); return; }
      if(password !== confirm) { setError('Passwords do not match.'); return; }
    }
    setLoading(true);
    if(mode === 'login') {
      const { data, error: err } = await supabase.auth.signInWithPassword({ email, password });
      if(err) { setError(err.message); setLoading(false); return; }
      onLogin({ name: data.user.user_metadata?.name || email.split('@')[0], email: data.user.email, id: data.user.id });
    } else {
      const { data, error: err } = await supabase.auth.signUp({
        email, password,
        options: { data: { name } }
      });
      if(err) { setError(err.message); setLoading(false); return; }
      if(data.user && !data.session) {
        setMessage('Check your email to confirm your account, then sign in!');
        setLoading(false); return;
      }
      onLogin({ name, email: data.user.email, id: data.user.id });
    }
    setLoading(false);
  }

  async function handleForgotPassword() {
    if(!email) { setError('Enter your email address first.'); return; }
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://www.thegroovetrading.com',
    });
    if(err) setError(err.message);
    else setMessage('Password reset email sent! Check your inbox.');
  }

  return (
    <div className="lg-page">
      <button className="lg-back" onClick={onBack}>← Back to The Groove Trading</button>
      <div className="lg-card">
        <div className="lg-logo">
          <div className="lg-logo-icon">GT</div>
          <div>
            <div className="lg-logo-name">The Groove Trading</div>
            <div className="lg-logo-sub">Finally Finding the Groove</div>
          </div>
        </div>
        <div className="lg-tabs">
          <button className={`lg-tab ${mode==='login'?'active':''}`} onClick={()=>{setMode('login');setError('');setMessage('');}}>Sign In</button>
          <button className={`lg-tab ${mode==='signup'?'active':''}`} onClick={()=>{setMode('signup');setError('');setMessage('');}}>Create Account</button>
        </div>
        <form className="lg-form" onSubmit={handleSubmit}>
          {mode==='signup' && (
            <div className="lg-field">
              <label>Full Name</label>
              <input type="text" placeholder="Nathan Mulligan" value={name} onChange={e=>setName(e.target.value)} autoComplete="name"/>
            </div>
          )}
          <div className="lg-field">
            <label>Email Address</label>
            <input type="email" placeholder="you@example.com" value={email} onChange={e=>setEmail(e.target.value)} autoComplete="email"/>
          </div>
          <div className="lg-field">
            <label>Password</label>
            <input type="password" placeholder="••••••••" value={password} onChange={e=>setPassword(e.target.value)} autoComplete={mode==='login'?'current-password':'new-password'}/>
          </div>
          {mode==='signup' && (
            <div className="lg-field">
              <label>Confirm Password</label>
              <input type="password" placeholder="••••••••" value={confirm} onChange={e=>setConfirm(e.target.value)} autoComplete="new-password"/>
            </div>
          )}
          {error && <div className="lg-error">{error}</div>}
          {message && <div style={{background:'#0d2818',border:'1px solid #166534',borderRadius:7,padding:'9px 12px',fontSize:11,color:'#86efac'}}>{message}</div>}
          {mode==='login' && (
            <div className="lg-forgot">
              <button type="button" className="lg-link" onClick={handleForgotPassword}>Forgot password?</button>
            </div>
          )}
          <button className="lg-submit" type="submit" disabled={loading}>
            {loading?<span className="lg-spinner"></span>:mode==='login'?'Sign In to The Groove':'Create My Account'}
          </button>
        </form>
        <div className="lg-divider"><span>or</span></div>
        <button className="lg-social-btn" style={{width:'100%',justifyContent:'center'}} onClick={async()=>{
          await supabase.auth.signInWithOAuth({provider:'google',options:{redirectTo:'https://www.thegroovetrading.com'}});
        }}>
          <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Continue with Google
        </button>
        {mode==='signup' && (
          <div className="lg-plan-info">
            <div className="lg-plan-icon">🎵</div>
            <div>
              <div className="lg-plan-title">Start with Free — upgrade anytime</div>
              <div className="lg-plan-desc">Live charts, paper trading on all brokers, trade journal. No credit card required.</div>
            </div>
          </div>
        )}
        <div className="lg-terms">
          By continuing you agree to our Terms of Service and Privacy Policy.
          This platform is for educational paper trading only and is not financial advice.
        </div>
      </div>
    </div>
  );
}